import { StateCreator } from 'zustand';

export type BreadcrumbsSlice = {
    additionalParams: Record<string, any> | undefined;
};

export const createBreadcrumbsSlice: StateCreator<BreadcrumbsSlice, [], [], BreadcrumbsSlice> = (set) => ({
    additionalParams: undefined,
    setAdditionalParams: (params: { pathname: string; params: any }) =>
        set((state) => ({
            additionalParams: {
                ...state.additionalParams,
                [params.pathname]: params.params
            }
        }))
});
